import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { helpRoutes } from '../../routes';
import { useGetAllCategories } from '../../sic-lib/api/hooks/useHelp';
import Loader from '../Shared/Loader';

export default function HelpCategories() {
    const { classes } = useStyles();
    const history = useHistory();
    const { pathname } = useLocation();

    const { data: categories, isLoading: isCategoriesLoading } = useGetAllCategories();

    const handleClick = (categoryId: number) => {
        if (categoryId === -1) {
            history.push(helpRoutes.helpHome);
        } else {
            history.push(helpRoutes.setCategory(categoryId));
        }
    };

    return (
        <>
            <List className={classes.root}>
                <ListItem key="Home" className={classes.innerItem}>
                    <ListItemButton
                        className={classes.innerButton}
                        selected={pathname === helpRoutes.helpHome}
                        onClick={() => {
                            handleClick(-1);
                        }}
                    >
                        <ListItemIcon>
                            <ChevronRightIcon className={classes.innerIcon} />
                        </ListItemIcon>
                        <ListItemText primary="Home" />
                    </ListItemButton>
                </ListItem>
                <ListItem sx={{ mb: 1, mt: 1 }}>
                    <ListItemText
                        primary="Categories"
                        primaryTypographyProps={{ sx: { fontWeight: 600 } }}
                    />
                </ListItem>
                <Loader isLoading={isCategoriesLoading}>
                    {categories &&
                        categories.map(category => (
                            <ListItem key={category.categoryId} className={classes.innerItem}>
                                <ListItemButton
                                    className={classes.innerButton}
                                    selected={
                                        pathname === helpRoutes.setCategory(category.categoryId)
                                    }
                                    onClick={() => {
                                        handleClick(category.categoryId);
                                    }}
                                >
                                    <ListItemIcon>
                                        <ChevronRightIcon className={classes.innerIcon} />
                                    </ListItemIcon>
                                    <ListItemText primary={category.categoryName} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                </Loader>
            </List>
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        // height: '100%',
        paddingTop: 0,
    },
    innerIcon: {
        fontSize: '18px',
    },
    innerItem: {
        padding: '2px 8px 2px 8px',
        //paddingLeft: theme.spacing(2),
    },
    innerButton: {
        borderRadius: theme.shape.borderRadius,
        //paddingLeft: theme.spacing(4),
    },
}));
